import Can from "../../utils/can";
import Vehicles from "../systemsettings/vechiles";

const VehiclesPage = () => {
  return (
    <div className="row">
      <Can permission={"view_vehicle"}>
        <Vehicles />
      </Can>
    </div>
  );
};

export default VehiclesPage;
